export const sizePerPageList = [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '50', value: 50 },
];

// default value untuk payment disabled sampai info berikutnya
export const initialFilter = {
    filter: {
        name: '',
        status: 'REQUEST',
        start_date:'',
        end_date:'',
        paymentType: 'EDC, TUNAI dan EDC + TUNAI'
    },
    pageNumber: 1,
    pageSize: 10,
};

export const collectStatusList = [
    { value: 'REQUEST' },
    { value: 'APPROVED' },
];
// default value untuk payment disabled sampai info berikutnya
export const paymentTypeList = [
    {value: 'EDC, TUNAI dan EDC + TUNAI'},
    {value: 'TUNAI'},
    {value: 'EDC'},
    {value: 'EDC + TUNAI'},
]
